<ul *ngIf="editJDState.activeStep$ | async as activeStep" class="menu-tabs px-4 mb-0">
    <li *ngFor="let item of menuItems" class="menu-tab">
        <a class="menu-tab-link" [class.disabled]="disabled" (click)="goToStep(item.field, activeStep)" [class.menu-tab-link--active]="item.field === activeStep">{{
            item.text
            }}</a>
    </li>
</ul>
